import React from 'react'
import { darken, Grid, makeStyles, Paper } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  item: {
    padding: theme.spacing(4),
    height: 190,
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: darken(theme.palette.background.paper, 0.01),
    },
  },
}))

type Props<T> = {
  items: T[]
  idGetter: (item: T) => string
  renderItem: (item: T) => React.ReactNode
  onItemClick: (item: T) => void
}

export function SystemContainerList<T>({
  items,
  idGetter,
  renderItem,
  onItemClick,
}: Props<T>): React.ReactElement {
  const classes = useStyles()

  return (
    <Grid container spacing={2}>
      {items.map((item) => (
        <Grid item xs={12} sm={12} md={6} lg={4} key={idGetter(item)}>
          <Paper
            className={classes.item}
            variant="elevation"
            elevation={0}
            tabIndex={0}
            onClick={() => onItemClick(item)}
          >
            {renderItem(item)}
          </Paper>
        </Grid>
      ))}
    </Grid>
  )
}
